import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DashboardIcon from "~src/assets/images/dashboard_icon.png";
import { useDashboards } from "../../data/dashboards";
import callAPI from "../../utils/callAPI";
import { SyncLoader } from "react-spinners";
import { NAVBAR_BLUE, WHITE } from "~src/data/constant";
 
const ModifiedListItemIcon = styled(ListItemIcon)(() => ({ minWidth: "20px" }));
 
const Dropdown = ({ pathName, ToggleDash, setWork, setIsDialogueOpen }) => {
  const { dashboards, loading, setLoading, error, fetchDashboardList } =
    useDashboards();
  const [anchorEl, setAnchorEl] = useState(null);
  const [creatingDashboard, setCreatingDashboard] = useState(false);
  const [newDashboardName, setNewDashboardName] = useState("");
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
 
  const handleMenuOpen = (event) => {
    // console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
  };
 
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
 
  const handleCreateNewClick = () => {
    setIsDialogueOpen(true);
    setCreatingDashboard(true);
    setNewDashboardName("");
    setOpenCreateDialog(true);
  };
 
  const handleCreateDashboard = () => {
    if (newDashboardName && newDashboardName !== "") {
      const body = { name: newDashboardName, widgets: [] };
      try {
        setLoading(true);
        callAPI(
          "POST",
          "create_save_dashboard/",
          JSON.stringify(body),
          ""
        ).then((res) => {
          if (res.msg === "success") {
            fetchDashboardList();
          }
        });
      } catch (error) {
        alert("Error Occured.");
      }
      setCreatingDashboard(false);
      setNewDashboardName("");
      setOpenCreateDialog(false);
    }
  };
 
  const handleCancelCreate = () => {
    setIsDialogueOpen(false);
    setCreatingDashboard(false);
    setNewDashboardName("");
    setOpenCreateDialog(false);
  };
 
  const handleDashboardClick = (dashboardId) => {
    ToggleDash();
    handleMenuClose();
  };
 
  return (
    <div>
      <Paper elevation={0} square>
        <div style={{ height: "auto",width:"fit-content", marginTop: 50 }}>
          {/* 

          <ListItem button onClick={handleMenuOpen}>
            <ModifiedListItemIcon>
              <SpaceDashboardIcon sx={{ fontSize: 14 }} />
            </ModifiedListItemIcon>
            <ListItemText
              disableTypography
              className="ms-2"
              primary={
                <Typography variant="body2" style={{ fontSize: 14 }}>
                  Dashboards
                </Typography>
              }
            />
          </ListItem> */}
 
          <Typography variant="h5" sx={{ marginLeft: 5 }}>
            Dashboards
          </Typography>
 
          <div className="mt-10 ml-6">
            {loading ? (
              <div className="w-100 d-flex align-items-center justify-content-center">
                <SyncLoader size={10} color={NAVBAR_BLUE} />
              </div>
            ) : error ? (
              <MenuItem disabled>{error}</MenuItem>
            ) : creatingDashboard ? (
              <Dialog
                open={openCreateDialog}
                onClose={handleCancelCreate}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle style={{ fontSize: "16px" }}>
                  Create New Dashboard
                </DialogTitle>
                <DialogContent style={{ paddingTop: "5px", fontSize: 16 }}>
                  <TextField
                    style={{ fontSize: "16px" }}
                    label="Dashboard Name"
                    value={newDashboardName}
                    onChange={(e) => setNewDashboardName(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCancelCreate}>Cancel</Button>
                  <Button onClick={handleCreateDashboard}>Create</Button>
                </DialogActions>
              </Dialog>
            ) : (
              <Paper
                elevation={0}
                square
                // style={{
                //   boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)", // Adjust the values as needed
                // }}
              >
                <div
                  style={{
                    marginLeft: "1.3rem",
                    marginTop: "-0.9rem",
                    minWidth: "11rem",
                    width:"fit-content"
                  }}
                >
                  {/* Predefined Dashboard Options */}
                  <MenuItem
                    className="dashboard_listItem"
                    component={Link}
                    to="/utilization-dashboard"
                    onClick={() => handleDashboardClick('utilization')}
                  >
                    <img
                      className="me-1"
                      src={DashboardIcon}
                      alt=""
                      height={20}
                      width={20}
                    />
                    Utilization Dashboard
                  </MenuItem>
                  
                  <MenuItem
                    className="dashboard_listItem"
                    component={Link}
                    to="/fwa-dashboard"
                    onClick={() => handleDashboardClick('fwa')}
                  >
                    <img
                      className="me-1"
                      src={DashboardIcon}
                      alt=""
                      height={20}
                      width={20}
                    />
                    Fraud Waste and Abuse
                  </MenuItem>
                  
                  <MenuItem divider />
                  
                  <MenuItem
                    className="d-flex"
                    style={{
                      fontSize: "12px",
                      textAlign: "left",
                      background: "white",
                      cursor: "default",
                    }}
                  >
                    <div
                      className="me-4 bold-hover"
                      style={{
                        width: "65%",
                        cursor: "pointer",
                        color: "#dd6f6f",
                      }}
                      onClick={handleCreateNewClick}
                    >
                      Create New +
                    </div>
                    <div
                      style={{ cursor: "pointer", width: "25%" }}
                      // onClick={() => fetchDashboardList()}
                    >
                      {/* <CachedIcon
                        style={{
                          fontSize: "1rem",
                          color: NAVBAR_BLUE,
                        }}
                      /> */}
                    </div>
                  </MenuItem>
                  <MenuItem divider />
                  {dashboards.map((dashboard) => (
                    <MenuItem
                      className="dashboard_listItem"
                      key={dashboard.id}
                      onClick={() => handleDashboardClick(dashboard.id)}
                      component={Link}
                      to={`/dashboard/${dashboard.id}_${dashboard.name}`}
                    >
                      <img
                        className="me-1"
                        src={DashboardIcon}
                        alt=""
                        height={20}
                        width={20}
                      />
                      {dashboard.name}
                    </MenuItem>
                  ))}
                </div>
              </Paper>
            )}
          </div>
 
          {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{ elevation: 0, style: { margin: "4px" } }}
          >
            {loading ? (
              <MenuItem disabled>Loading...</MenuItem>
            ) : error ? (
              <MenuItem disabled>{error}</MenuItem>
            ) : creatingDashboard ? (
              <Dialog
                open={openCreateDialog}
                onClose={handleCancelCreate}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle style={{ fontSize: "16px" }}>
                  Create New Dashboard
                </DialogTitle>
                <DialogContent style={{ paddingTop: "5px", fontSize: 16 }}>
                  <TextField
                    style={{ fontSize: "16px" }}
                    label="Dashboard Name"
                    value={newDashboardName}
                    onChange={(e) => setNewDashboardName(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCancelCreate}>Cancel</Button>
                  <Button onClick={handleCreateDashboard}>Create</Button>
                </DialogActions>
              </Dialog>
            ) : (
              <Paper
                elevation={0}
                square
                style={{
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)", // Adjust the values as needed
                }}
              >
                <div
                  style={{
                    marginLeft: "1.3rem",
                    marginTop: "-0.9rem",
                    minWidth: "11rem",
                  }}
                >
                  <MenuItem
                    className="d-flex"
                    style={{
                      fontSize: "12px",
                      textAlign: "left",
                      background: "white",
                      cursor: "default",
                    }}
                  >
                    <div
                      className="me-4 bold-hover"
                      style={{
                        width: "65%",
                        cursor: "pointer",
                        color: "#dd6f6f",
                      }}
                      onClick={handleCreateNewClick}
                    >
                      Create New +
                    </div>
                    <div
                      style={{ cursor: "pointer", width: "25%" }}
                      // onClick={() => fetchDashboardList()}
                    >
                      {/* <CachedIcon
                        style={{
                          fontSize: "1rem",
                          color: NAVBAR_BLUE,
                        }}
                      /> */}
          {/* </div>
                  </MenuItem>
                  <MenuItem divider />
                  {dashboards.map((dashboard) => (
                    <MenuItem
                      className="dashboard_listItem"
                      key={dashboard.id}
                      onClick={() => handleDashboardClick(dashboard.id)}
                      component={Link}
                      to={`/dashboard/${dashboard.id}_${dashboard.name}`}
                    >
                      <img
                        className="me-1"
                        src={DashboardIcon}
                        alt=""
                        height={20}
                        width={20}
                      />
                      {dashboard.name}
                    </MenuItem>
                  ))}
                </div>
              </Paper>
            )} */}
          {/* <NavLink onClick={handleMenuClose} to="/widget-generator">
              <ListItem button>
                <ModifiedListItemIcon>
                  <PolylineIcon
                    sx={{ fontSize: "15px" }}
                    color={pathName === "/widget-generator" ? "primary" : ""}
                  />
                </ModifiedListItemIcon>
 
                <ListItemText
                  disableTypography
                  className="ms-2"
                  primary={
                    <Typography
                      variant="body2"
                      color={pathName === "/widget-generator" ? "primary" : ""}
                      style={{
                        fontSize: "1rem",
                      }}
                    >
                      Widget Generator
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink> */}
          {/* </Menu> */}
        </div>
      </Paper>
    </div>
  );
};
 
export default Dropdown;